var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFillBusinessSendPlaneFillPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3207_11053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9012 7.91524C11.6596 7.42089 11.8566 7.22043 12.3606 7.47814L30.2737 16.6384C30.7699 16.8925 30.771 17.3161 30.2977 17.5734L12.8589 27.0554C12.3764 27.3191 12.1498 27.1141 12.351 26.6025L15.6033 18.3712L25.5152 17.0465L15.6289 15.5429L11.9012 7.91524Z",
    fill: "#660099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3207_11053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(17.1836) rotate(45.518)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillBusinessSendPlaneFillPurple);
export default __webpack_public_path__ + "static/media/icon-fill-business-send-plane-fill-purple.b4ac44110fad0624c58177ac0de1caa3.svg";
export { ForwardRef as ReactComponent };